import { useTranslation } from 'react-i18next';
import { useGet } from '@/query/fetchHooks';
import { useNavigate, useParams } from 'react-router-dom';
import ListOfPublications from './ListOfPublications';
import { Userwithorganisationwithidps } from '@/models';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { useContext, useState, useEffect } from 'react';
import EmptyTable from '@/components/DataTable/EmptyTable';
import { parseQueryString } from '@/util';
import TypeCourse from '@/components/CreateNewPublication/TypeCourse';
import { TEOLoader } from '@teo/components';

function CreateIndexPage() {
  const { t } = useTranslation();
  const { organisationId } = useParams();
  const basePath = window.location.pathname;
  const navigate = useNavigate();
  const { auth } = useContext(AuthContext);
  const authUser = auth?.user as Userwithorganisationwithidps;
  const authLang: any = auth?.user.lang;
  const authOrg: any = auth?.user?.activeOrganisationId;
  const [courses, setCourses] = useState<any>(null);
  const [vacancies, setVacancies] = useState<any>(null);
  const [learningPaths, setLearningPaths] = useState<any>(null);
  const [assessments, setAssessments] = useState<any>(null);
  const [instructions, setInstructions] = useState<any>(null);
  const [dashboardCreate, setDashboardCreate] = useState<any>(null);

  const [goToCreate, setGoToCreate] = useState(false);
  const [publicationId, setPublicationId] = useState();

  const queries = parseQueryString(document.location.search) as {
    [key: string]: string;
  };

  const [isOpenTypeModal, setIsOpenTypeModal] = useState(
    !!queries['courseType']
  );

  const [template, setTemplate] = useState('theory');
  // const [typeCourse, setTypeCourse] = useState('courses');

  useGet('/myowedpublications', {
    enabled: !!authUser?.useCourse,
    userId: authUser?.id,
    organisationId,
    publicationCourseType: 'course',
    publicationStatus:
      'published,OR,publicationStatus=concept,OR,publicationStatus=template,OR,publicationStatus=concept-template,OR,publicationStatus=published-template',
    offset: 0,
    count: 4,
    sort: '-updatedAt',
    onSuccess: (result: any) => {
      setCourses(result?.data || []);
      setDashboardCreate((prev: any) =>
        prev ? [...prev, ...(result?.data || [])] : [...(result?.data || [])]
      );
    },
  });

  useGet('/mylps', {
    enabled: !!authUser?.useLp,
    userId: authUser?.id,
    organisationId,
    lpIsRoot: true,
    masterId: 'null',
    lpPublicationStatus: 'published,OR,lpPublicationStatus=concept',
    offset: 0,
    count: 4,
    sort: '-updatedAt',
    onSuccess: (result: any) => {
      setLearningPaths(result?.data || []);
      setDashboardCreate((prev: any) =>
        prev ? [...prev, ...(result?.data || [])] : [...(result?.data || [])]
      );
    },
  });

  useGet('/myowedpublications', {
    enabled: !!authUser?.useAssessment,
    userId: authUser?.id,
    organisationId,
    publicationCourseType: 'assessment',
    publicationStatus:
      'published,OR,publicationStatus=concept,OR,publicationStatus=template,OR,publicationStatus=concept-template,OR,publicationStatus=published-template',
    offset: 0,
    count: 4,
    sort: '-updatedAt',
    onSuccess: (result: any) => {
      setAssessments(result?.data || []);
      setDashboardCreate((prev: any) =>
        prev ? [...prev, ...(result?.data || [])] : [...(result?.data || [])]
      );
    },
  });

  useGet('/myowedpublications', {
    enabled: !!authUser?.useLeervacature,
    userId: authUser?.id,
    organisationId,
    publicationCourseType: 'leervacature',
    publicationStatus:
      'published,OR,publicationStatus=concept,OR,publicationStatus=template,OR,publicationStatus=concept-template,OR,publicationStatus=published-template',
    offset: 0,
    count: 4,
    sort: '-updatedAt',
    onSuccess: (result: any) => {
      setVacancies(result?.data || []);
      setDashboardCreate((prev: any) =>
        prev ? [...prev, ...(result?.data || [])] : [...(result?.data || [])]
      );
    },
  });

  useGet('/myowedpublications', {
    enabled: !!authUser?.useInstruction,
    userId: authUser?.id,
    organisationId,
    publicationCourseType: 'instruction',
    publicationStatus:
      'published,OR,publicationStatus=concept,OR,publicationStatus=template,OR,publicationStatus=concept-template,OR,publicationStatus=published-template',
    offset: 0,
    count: 4,
    sort: '-updatedAt',
    onSuccess: (result: any) => {
      setInstructions(result?.data || []);
      setDashboardCreate((prev: any) =>
        prev ? [...prev, ...(result?.data || [])] : [...(result?.data || [])]
      );
    },
  });

  useEffect(() => {
    if (goToCreate) {
      setIsOpenTypeModal(false);
      navigate(`/${authLang}/create/${authOrg}/courses/${publicationId}`);
    }
  }, [goToCreate]);

  const courseType = authUser?.useCourse;
  const assessmentType = authUser?.useAssessment;
  const vacancyType = authUser?.useLeervacature;
  const instructionType = authUser?.useInstruction;
  const lpType = authUser?.useLp;

  // if (!courses || !assessments || !vacancies || !instructions || !learningPaths)
  //   return null;

  return !isOpenTypeModal ? (
    <div className="w-full">
      <div className="flex w-full justify-between ">
        <div
          className="w-full pb-10"
          style={{
            background:
              'url("/images/components/create/create_index_img.svg") no-repeat center right',
            backgroundSize: 'contain',
          }}
        >
          <h1 className="pt-2 text-2xl font-bold text-black">
            {t('pages.create_index.title')}
          </h1>
          <div className="mt-4 max-w-[532px] pb-4.5 text-sm font-normal text-[#7d7d81]">
            {t('pages.create_index.description')}
          </div>
        </div>
      </div>
      {!dashboardCreate && (
        <div className="mx-auto flex justify-center py-[100px] px-10">
          <TEOLoader loaderSrc="/images/TEOloader.gif" className="w-[100px]" />
        </div>
      )}

      {courseType && courses && (
        <ListOfPublications
          basePath={`${basePath}/courses`}
          courses={courses}
          type={'courses'}
        />
      )}

      {lpType && learningPaths && (
        <ListOfPublications
          basePath={`${basePath}/learning-paths`}
          courses={learningPaths}
          type={'learning-paths'}
        />
      )}

      {assessmentType && assessments && (
        <ListOfPublications
          basePath={`${basePath}/assessments`}
          courses={assessments}
          type={'assessments'}
        />
      )}

      {vacancyType && vacancies && (
        <ListOfPublications
          basePath={`${basePath}/vacancies`}
          courses={vacancies}
          type={'leervacatures'}
        />
      )}

      {instructionType && instructions && (
        <ListOfPublications
          basePath={`${basePath}/instructions`}
          courses={instructions}
          type={'instructions'}
        />
      )}
      <div
        className={`w-full ${
          dashboardCreate && !dashboardCreate?.length ? 'block' : 'hidden'
        }`}
      >
        <EmptyTable
          template={2}
          text={t('empty_tenplate.course_list')}
          btn_text={t('empty_tenplate.btn_creat_course')}
          btnClick={() => setIsOpenTypeModal(true)}
        />{' '}
      </div>
    </div>
  ) : (
    <TypeCourse
      setIsOpenTypeModal={setIsOpenTypeModal}
      setTemplate={setTemplate}
      template={template}
      setGoToCreate={setGoToCreate}
      typeCourse={'courses'}
      setPublicationId={setPublicationId}
      publicationId={publicationId}
    />
  );
}

export default CreateIndexPage;
